module.exports = __webpack_public_path__ + "img/caishen_320.7db8e5bc.png";